export default __webpack_public_path__ + "static/stelrad-559e3c0989213189cd93623286170b37.png";